module.exports = __webpack_public_path__ + "img/customer-a-002.7c21d5cf.png";